/**
 * Exact WEB-937 copy for the anonymous Discover access card. Fixture numbers
 * from the v3 handoff never ship — `{N}` is the live envelope total, or the
 * number is dropped when the date preset is not the default upcoming window.
 */
import type { DateValue } from '@/lib/discover/url-state';
import { formatCount } from '@/lib/format/count';

export const ACCESS_CARD_TITLE = 'Everything is here without an account';
export const ACCESS_CARD_PRIMARY_LABEL = 'Create an account';
export const ACCESS_CARD_SIGN_IN_LABEL = 'sign in';
export const ACCESS_CARD_NEXT_PATH = '/discover';

const BODY_LEAD_PREFIX = 'All ';
const BODY_LEAD_WITH_COUNT = ' upcoming events, every filter and the map. No sign-in.';
const BODY_LEAD_WITHOUT_COUNT = 'All upcoming events, every filter and the map. No sign-in.';
const BODY_TRAIL = ' An account adds picks with reasons, saves and your location.';

/**
 * Default Discover date is "upcoming": `date` is omitted from the URL
 * (`defaultDiscoverParams` does not set it). Any named preset or custom ISO
 * range is a non-default window and must not pair a scoped count with the
 * word "upcoming".
 */
export function isDefaultUpcomingDate(date: DateValue | undefined): boolean {
  return date === undefined;
}

export type AnonymousAccessCountState =
  | { readonly kind: 'upcoming'; readonly total: number }
  | { readonly kind: 'pending' }
  | { readonly kind: 'non-default' };

export function resolveAnonymousAccessCountState(
  date: DateValue | undefined,
  total: number | undefined,
): AnonymousAccessCountState {
  if (!isDefaultUpcomingDate(date)) return { kind: 'non-default' };
  if (typeof total !== 'number' || !Number.isFinite(total)) return { kind: 'pending' };
  return { kind: 'upcoming', total };
}

export function anonymousAccessBodyWithCount(total: number): string {
  return `${BODY_LEAD_PREFIX}${formatCount(total)}${BODY_LEAD_WITH_COUNT}${BODY_TRAIL}`;
}

export function anonymousAccessBodyWithoutCount(): string {
  return `${BODY_LEAD_WITHOUT_COUNT}${BODY_TRAIL}`;
}

export const ANONYMOUS_ACCESS_BODY_PENDING_PREFIX = BODY_LEAD_PREFIX;
export const ANONYMOUS_ACCESS_BODY_PENDING_SUFFIX = `${BODY_LEAD_WITH_COUNT}${BODY_TRAIL}`;
